import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://high.innohed.com/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username: string, password: string) =>
    api.post('/v1/auth/login', { username, password }),
};

export const accountAPI = {
  getAll: () => api.get('/v1/accounts'),
  getABook: () => api.get('/v1/accounts/a-book'),
  getOne: (accountId: string) => api.get(`/v1/accounts/${accountId}`),
  getHistory: (accountId: string) => api.get(`/v1/accounts/${accountId}/history`),
  returnToBBook: (accountId: string) => api.post(`/v1/accounts/${accountId}/return-to-b`),
  getAccountsByGroup: (group: string) => api.get(`/v1/accounts/groups/accounts?group=${encodeURIComponent(group)}`),
  getGroups: () => api.get('/v1/accounts/groups'),
  register: (data: any) => api.post('/v1/accounts', data),
  health: () => api.get('/v1/accounts/health'),
};

export const rulesAPI = {
  getAll: () => api.get('/v1/rules'),
  create: (data: any) => api.post('/v1/rules', data),
  update: (id: number, data: any) => api.put(`/v1/rules/${id}`, data),
  delete: (id: number) => api.delete(`/v1/rules/${id}`),
};

export const positionAPI = {
  getFloating: () => api.get('/v1/positions/floating'),
  getByAccount: (accountId: string) => api.get(`/v1/positions/${accountId}`),
};

export const patternAPI = {
  getRecommendations: () => api.get('/v1/pattern/recommendations'),
  getBBookRecommendations: () => api.get('/v1/pattern/recommendations/b-book'),
  getABookRecommendations: () => api.get('/v1/pattern/recommendations/a-book'),
  getAccountPattern: (login: string) => api.get(`/v1/pattern/${login}`),
  getShortHighWinRate: () => api.get('/v1/pattern/short-high-winrate'),
  getLongStable: () => api.get('/v1/pattern/long-stable'),
  getHighPayoff: () => api.get('/v1/pattern/high-payoff'),
  getNormalLoss: () => api.get('/v1/pattern/normal-loss'),
  getAccountSnapshot: (login: number) => api.get(`/v1/pattern/account/${login}/snapshot`),
  getAccountDaily: (login: number) => api.get(`/v1/pattern/account/${login}/daily`),
  getAccountThreshold: (login: number) => api.get(`/v1/pattern/account/${login}/threshold`),
};

export default api;
